<div class="lookup-container">
  <!-- setting autocomplete value stops field autocompleting -->
  <input
    type="text"
    class="lookup"
    autocomplete="residence_name"
    (keyup)="lookupChange()"
    [value]="searchTermState()"
    [class.searching]="isSearching()"
    (blur)="onBlur($event)"
    #lookup
  />
  <div class="spinner" *ngIf="isSearching()"></div>
  <div class="lookup-results" *ngIf="apiResponse() as apiResponse">
    <li
      class="residence-lookup-result"
      *ngFor="let residence of apiResponse"
      (click)="selectResidence(residence)"
    >
      {{ residence.name }}
    </li>
    <p *ngIf="!apiResponse.length">
      {{ noResidencesFoundMessage }} '{{ searchTermState() }}'
    </p>
  </div>

  <div class="error-block">
    <app-error-block *ngIf="lookupError()">
      There was an error searching for your college&#47;university.
    </app-error-block>
  </div>

  <p *ngIf="apiResponse()" class="add-links">
    <a (click)="doLivingAtHome()">I'm living at home</a>
    <a (click)="doPrivateLet()">I have a private let or rental</a>
  </p>
</div>
